<template>
  <label :class="wrapClasses">
    <input
      v-if="group"
      :class="inputClasses"
      :disabled="disabled"
      :value="label"
      v-model="model"
      type="checkbox"
      @change="_change"
      @focus="focus = true"
      @blur="focus = false">
    <input
      v-if="!group"
      :class="inputClasses"
      :disabled="disabled"
      :checked="currentValue"
      type="checkbox"
      @change="_change"
      @focus="focus = true"
      @blur="focus = false">
    <span :class="innerClasses">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>
<script>
import { findComponentUpward } from '../../utils/assist'
import Emitter from '../../mixins/emitter'
const prefixCls = 'form-checkbox'
export default {
  name: 'TCheckbox',
  mixins: [Emitter],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Number, Boolean]
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['lg', 'sm', ''].includes(value)
      }
    }
  },
  data() {
    return {
      model: [],
      currentValue: this.value,
      group: false,
      showSlot: true,
      parent: findComponentUpward(this, 'CheckboxGroup')
    }
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}--checked`]: this.currentValue,
          [`${prefixCls}--disabled`]: this.disabled,
          [`${prefixCls}--indeterminate`]: this.indeterminate,
          [`${prefixCls}--${this.size}`]: !!this.size
        }
      ]
    },
    innerClasses() {
      return `${prefixCls}__inner`
    },
    inputClasses() {
      return `${prefixCls}__input`
    }
  },
  watch: {
    value() {
      this._updateModel()
    },
    indeterminate(val) {
      if (val === false && this.value === false) {
        this._changeCheck(false)
      }
    }
  },
  mounted() {
    this.parent = findComponentUpward(this, 'TCheckboxGroup')
    if (this.parent) this.group = true
    if (!this.group) {
      this._updateModel()
      this.showSlot = this.$slots.default !== undefined
    } else {
      this.parent._updateModel(true)
    }
  },
  methods: {
    _change(event) {
      if (this.disabled) {
        return false
      }
      const checked = event.target.checked
      this._changeCheck(checked)
    },
    _changeCheck(checked) {
      if (checked === this.currentValue) {
        return
      }
      this.currentValue = checked
      this.$emit('input', checked)
      if (this.group) {
        this.parent._change(this.model)
      } else {
        this.$emit('on-change', checked)
        this.dispatch('TFormItem', 'on-form-change', checked)
      }
    },
    _updateModel() {
      this.currentValue = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// checkbox.vue?66d598d6